export const xs = 1
export const sm = 640
export const md = 768
export const lg = 1024
export const xl = 1280
export const xxl = 1536
export const xxxl = 1920

export const mdUp = `(min-width: ${md}px)`
export const lgUp = `(min-width: ${lg}px)`
export const lgDown = `(max-width: ${lg}px)`
